import { IProduct } from "../type/IProduct";
import { IProductMap } from "../type/IProductMap";

export const getProductsByIds = (ids: string[], productMap: IProductMap): IProduct[] => ids.map((id) => productMap[id]).filter(product => product !== undefined) as IProduct[];